/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletGroupIcon20Solid = forwardRef('TextBulletGroupIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 4.25C2 3.56 2.56 3 3.25 3h3.5C7.44 3 8 3.56 8 4.25v3.5C8 8.44 7.44 9 6.75 9h-3.5C2.56 9 2 8.44 2 7.75v-3.5Z" }),
        React.createElement("path", { d: "M10 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M11 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" }),
        React.createElement("path", { d: "M11 15a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" }),
        React.createElement("path", { d: "M11 7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" }),
        React.createElement("path", { d: "M3.25 11C2.56 11 2 11.56 2 12.25v3.5c0 .69.56 1.25 1.25 1.25h3.5C7.44 17 8 16.44 8 15.75v-3.5C8 11.56 7.44 11 6.75 11h-3.5Z" })));
});
